import * as ko from 'knockout';
import * as _ from 'underscore';

import {RenderModes, CONTROL_TYPES} from "Core/Constant";
import {BaseControl, IControlValue} from 'Core/Controls/BaseControl/BaseControl';
import {IControlParam} from "Core/Screens/IScreen";
import {GeneralProperties} from "Core/GeneralProperties/GeneralProperties";
import {TriggerModel} from 'Core/Controls/BaseControl/Models/TriggerModel';
import {TRIGGER_ACTIONS} from 'Core/Constants/TriggerActions';
import {TRIGGER_PARAMS} from 'Core/Constants/TriggerParams';
import {
    IParamModel,
    IExecuteTriggerRequestModel,
    TriggerStore
} from 'Core/Components/Triggers/TriggerStore';
import {BlockUI} from 'Core/Common/BlockUi';
import {Notifier} from 'Core/Common/Notifier';
import {IconModel} from "../BaseControl/Models/IconModel";
import {GenericButtonConfigModel} from 'Core/Controls/Grid/Models/GridDataModel/QueryExpression/GenericButtonConfigModel';
import {NOTIFICATIONS} from 'Core/Components/Translation/Locales';
import {RecordKey} from 'Core/Controls/Grid/Models/GridDataModel/GridCellValueModel';
import {PUB_SUB_EVENTS} from 'MenuManager/PubSubEvents';

import Config from 'Core/Controls/ButtonAIWorkflow/Configs/config.json';

import ViewTemplate from 'Core/Controls/ButtonAIWorkflow/Templates/View.html';
import HelpViewTemplate from 'Core/Controls/ButtonAIWorkflow/Templates/HelpView.html';
import DesignTemplate from 'Core/Controls/ButtonAIWorkflow/Templates/Design.html';
import ToolBarTemplate from 'Core/Controls/ButtonAIWorkflow/Templates/ToolBar.html';
import { Assistant, AssistantModes } from 'DatabaseDesigner/Components/Assistant/Assistant';

ko.templates['Core/Controls/ButtonAIWorkflow/Templates/View'] = ViewTemplate;
ko.templates['Core/Controls/ButtonAIWorkflow/Templates/HelpView'] = HelpViewTemplate;
ko.templates['Core/Controls/ButtonAIWorkflow/Templates/Edit'] = ViewTemplate;
ko.templates['Core/Controls/ButtonAIWorkflow/Templates/Design'] = DesignTemplate;
ko.templates['Core/Controls/ButtonAIWorkflow/Templates/ToolBar'] = ToolBarTemplate;

export class ButtonAIWorkflow extends BaseControl {
    private _config: any;
    private _iconColor: KnockoutObservable<string>;
    private _nameInTooltip: KnockoutObservable<boolean>;
    private _synchronousExecution: KnockoutObservable<boolean>;
    private _buttonClassName: KnockoutObservable<string>;
    private _iconModel = IconModel;

    constructor(params: IControlParam, controlConfig = Config) {
        super(params, controlConfig);

        this._style = ko.computed(() => {
            const paddingV = this._border() ? 6 : 7;
            const paddingH = this._border() || this._backgroundColor() ? 14 : 4;

            return {
                backgroundColor: this._backgroundColor(),
                color: this._color(),
                borderColor: this._borderColor(),
                borderWidth: this._border() ? '1px' : '0',
                padding: `${paddingV}px ${paddingH}px`
            };
        });

        this._iconColor = ko.observable(null);
        this._nameInTooltip = ko.observable(false);
        this._synchronousExecution = ko.observable(false);

        this.Init();
        this._icon(this._model().Icon);
        this._buttonClassName = ko.observable(this._iconModel.GetClasses(this._model().Icon?.FontName, this._model().Icon?.Name));
        
        this._icon.subscribe(() => {
            this._buttonClassName(this._iconModel.GetClasses(this._model().Icon?.FontName, this._model().Icon?.Name))
        });
    }

    async Click() {
        if (!this.IsDesignTime) {
            if (this._help.IsHelpButtonPressed()) {
                this._help.ShowControlHelp(this);
                return;
            }

            if (this.IsDisabledByCondition) {
                return;
            }

            let assistant = new Assistant({
                entityId: this.Screen.GetEntityId(),
                recordId: this.Screen.GetRecordId(),
                controlId: this.GetControlId(),
                mode: AssistantModes.Workflow
            });
            await assistant.LoadData();
            await assistant.Show();            
        }
    }

    private Init() {
        this.ApplyProperties();
    }

    SetValue(value: IControlValue): void {
        super.SetValue(value);
    }

    ApplyProperties() {
        if (this.Properties) {
            this.AssignProperty('Styling', 'BackgroundColor', this._backgroundColor);
            this.AssignProperty('Styling', 'TextColor', this._color);
            this.AssignProperty('Styling', 'Border', this._border);
            this.AssignProperty('Styling', 'IconColor', this._iconColor);
            this.AssignProperty('Styling', 'NameInTooltip', this._nameInTooltip);
            this.AssignProperty('Styling', 'BorderColor', this._borderColor);
            this.AssignProperty('Execution', 'SynchronousExecution', this._synchronousExecution)
        }
    }

    protected AssignProperty(groupedBy: string, propertyName: string, propertyHolder: KnockoutObservable<any> | any) {
        if (this.Properties[groupedBy]) {
            _.each(this.Properties[groupedBy].Properties,
                (property: any) => {
                    if (property.hasOwnProperty(propertyName)) {
                        propertyHolder(property[propertyName]);
                    }
                });
        }
    }

    private GetTooltipValue(): string {
        if (this._nameInTooltip()) {
            return this.Label();
        }
        return '';
    }
}
